<template>
  <li class="list-item open-num">
    <x-angleIcon></x-angleIcon>
    <h3><i class="iconfont iconicon_jiantou"></i>开门次数趋势图</h3>
    <div class="openNum" id="openNum"></div>
  </li>
</template>

<script>
import chartOpt from '@/utils/chartOptions';
export default {
  name: 'openNum',
  data () {
    return {
      cId: '',
      openNum: {}
    };
  },
  created () {
    this.getDataViewQuery(this);
  },
  mounted () {
    this.openNumChart();
  },
  methods: {
    /* 每天不同方式开门次数的叠加图 */
    async openNumChart () {
      this.openNum = this.Highcharts.chart('openNum', chartOpt.stackColOptions);
      this.getOpenNum();
    },
    /* 获取开门次数 */
    getOpenNum () {
      return new Promise((resolve, reject) => {
        this.$get({
          url: '/zw_statistics/opendoor_statistics',
          params: {community_id: this.cId},
          config: { timeout: 20000 }
        }).then(({data}) => {
          let res = this.transformData(data);
          this.openNum.series[0].setData(res.face);
          this.openNum.series[1].setData(res.blueTooth);
          this.openNum.series[2].setData(res.remote);
          this.openNum.series[3].setData(res.password);
          this.openNum.series[4].setData(res.card);
          this.openNum.series[5].setData(res.video);
          this.openNum.series[6].setData(res.indoorVideo);
          this.openNum.series[7].setData(res.indoorNet);
          this.openNum.series[8].setData(res.phone);
          this.openNum.series[9].setData(res.visitorPwd);

          this.openNum.xAxis[0].setCategories(res.date);
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  #openNum {
    height: 100%;
  }
</style>
